import React from "react";
import styled from "styled-components";

function MiddleText() {
  return <CustomDiv></CustomDiv>;
}

export default MiddleText;

const CustomDiv = styled.div`
  border: 1px solid white;
  height: 20%;
  width: 20%;
`;
